import { jsx as t } from "react/jsx-runtime";
const r = (l) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ t(
  "path",
  {
    fill: "#212134",
    d: "m12 18.26-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26Z"
  }
) }), o = r;
export {
  o as default
};
